
import { Component } from '@theme/component';

/**
 * FlyToCart animation disabled for SerenityEgy.
 * Keeps the custom element registered without animating product images.
 */
class FlyToCart extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.remove();
  }
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
